import { render, staticRenderFns } from "./GoodsCon.vue?vue&type=template&id=2b7c6b62&scoped=true&"
import script from "./GoodsCon.vue?vue&type=script&lang=js&"
export * from "./GoodsCon.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCon.vue?vue&type=style&index=0&id=2b7c6b62&scoped=true&lang=css&"
import style1 from "./GoodsCon.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7c6b62",
  null
  
)

export default component.exports